module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/tab-2-4fd43a329c3a3c91c0d6060d42fc5818.png";